<template>
  <page-header titolo="Configurazioni sito" icona="fa-cog" sfondo="bkg-config"></page-header>

  <div class="pol-container">

    <div class="card">
        <div class="card-header">
            <button type="button" class="btn btn-sm btn-warning" @click="disabled=false" v-if="disabled">
                <font-awesome-icon icon="fa-solid fa-lock-open"></font-awesome-icon>&nbsp;Sblocca configurazione
            </button>&nbsp;&nbsp;
            <button type="button" class="btn btn-sm btn-dark" @click="disabled=true" v-else>
                <font-awesome-icon icon="fa-solid fa-lock"></font-awesome-icon>&nbsp;Blocca configurazione
            </button>&nbsp;&nbsp;
            <button type="button" class="btn btn-sm btn-primary" :disabled="disabled" @click="SalvaConfig">
                <font-awesome-icon icon="fa-solid fa-floppy-disk"></font-awesome-icon>&nbsp;Salva
            </button>
        </div>
        <div class="card-body">

            <div class="alert alert-warning">ATTENZIONE! Modificare queste configurazioni solo se si è sicuri di quello che si sta facendo.</div>

            <div class="container">
            <form autocomplete="off">
                <div class="row mb-3">
                    <div class="col-md">
                        <label class="form-label">Server SMTP</label>
                        <input type="text" class="form-control" v-model="oConfig.sendMailServer" :disabled="disabled">
                    </div>
                    <div class="col-md-2">
                        <label class="form-label">Porta</label>
                        <input type="text" class="form-control" v-model="oConfig.sendMailSMTPPort" :disabled="disabled">
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-3">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="oConfig.sendMailSSL" :disabled="disabled">
                            <label class="form-check-label" >
                                Usa SSL
                            </label>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="oConfig.sendMailTLS" :disabled="disabled">
                            <label class="form-check-label" >
                                Usa STARTLS
                            </label>
                        </div>
                    </div>
                </div>
                
                
                <div class="mb-3">
                    <label class="form-label">Email del mittente</label>
                    <input type="text" class="form-control" v-model="oConfig.sendMailSender" :disabled="disabled">
                </div>

                
               <div class="mb-3">
                    <label class="form-label">Nome utente</label>
                    <input type="text" class="form-control" v-model="oConfig.sendMailUid" :disabled="disabled">
                </div>
                <div class="mb-3">
                    <label class="form-label">Password</label>
                    <input type="password" class="form-control" v-model="oConfig.sendMailPassword" :disabled="disabled">
                </div>
                
                
            </form>
            </div>
        </div>
        <div class="card-footer">
            
        </div>

    </div>

  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue';
import snFunctions from '@/lib/snFunctions.js';
import MessaggioStd from '@/components/MessaggioStandard.vue';

export default {
    name: "ConfigView",
    components: {PageHeader},
    inject: ['cfg'],
    data: function () {
        return {
            disabled: true,

            oConfig: {
                "sendMailServer": "",
                "sendMailSMTPPort": 25,
                "sendMailSender": "",
                "sendMailSSL": false,
                "sendMailTLS": false,
                "sendMailPassword": "",
                "sendMailUid": "",

                token: ""


            }

        }
    },
    methods: {
        GetConfig() {
            fetch(this.cfg.apisrv + "/api/Config/GetConfig?token=" + this.$store.state.UserInfo.token)
            .then(response => response.json())
            .then(obj => {
                
                this.oConfig = obj;
                
            });
        },
        SalvaConfig(reload) {
            let oSubmit = [];
            oSubmit = this.oConfig;
            oSubmit.token = this.$store.state.UserInfo.token;

            fetch(this.cfg.apisrv + "/api/Config/SalvaConfig", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.GetConfig();
                    }
                    else {
                    
                    }
                });

      },
    },
    mounted: function() {
        this.GetConfig();
    }
}
</script>

<style>

</style>